import type { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import * as z from "zod";
import { ReturnsCoverageBuilderInitialValueSchema } from "./save-coverage-builder";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function isCoverageBuilderPreviewAutocheck(
  value: unknown,
): value is WidgetAutocheck {
  return (
    isRecord(value) &&
    typeof value.displayIcon === "boolean" &&
    typeof value.storefrontAccessToken === "string" &&
    isRecord(value.cartToggle) &&
    isRecord(value.packageProtection) &&
    isRecord(value.finalSaleReturns)
  );
}

const CoverageBuilderPreviewAutocheckSchema = z.custom<WidgetAutocheck>(
  isCoverageBuilderPreviewAutocheck,
);

/** Explicit read model the embedded coverage builder needs during onboarding. */
export const getCoverageBuilderContext = {
  name: "getCoverageBuilderContext" as const,
  input: z.object({}),
  output: z.object({
    initialValue: ReturnsCoverageBuilderInitialValueSchema,
    previewAutocheck: CoverageBuilderPreviewAutocheckSchema,
    isShopifyPlus: z.boolean(),
  }),
};
